/**
 * @Description 小天才选址地图青春版
 */

import { get, post } from '../../request';

/**
 * 小天才全国门店
 * https://yapi.lanhanba.com/project/546/interface/api/89883
 */
export function getXTCAllStores() {
  return get(`/youth/map/combatMap/allStores`);
}

/**
 * 小天才全国门店城市权限
 * https://yapi.lanhanba.com/project/546/interface/api/89885
 */
export function getXTCPermissionCity() {
  return get(`/youth/map/combatMap/permission/city`);
}

/**
 * 小天才分公司列表
 * https://yapi.lanhanba.com/project/546/interface/api/89887
 */
export function getXTCCompanyList() {
  return get(`/youth/map/combatMap/branchCompany/list`);
}

/**
 * 小天才分公司信息
 * https://yapi.lanhanba.com/project/349/interface/api/90775
 */
export function getXTCMapCompanyList(params: any) {
  return post(`/youth/map/combatMap/branchCompany/map`, params, {
    needCancel: false,
  });
}

/**
 * 小天才分公司地图hover展示的销售趋势(全国视角时，hover的单个分公司)
 * https://yapi.lanhanba.com/project/349/interface/api/90928
 */
export function getXTCCompanySalesTrend(params: any) {
  return post(`/youth/map/combatMap/branchCompany/hover/salesTrend`, params);
}


/**
 * 小天才-国省视角-市场容量
 * https://yapi.lanhanba.com/project/349/interface/api/89881
 */
export function getXTCMarketCapacity(params: any) {
  return post(`/youth/map/combatMap/getCitySalesCompletionRate`, params);
}

/**
 * 小天才-城市视角-市场容量
 * https://yapi.lanhanba.com/project/349/interface/api/91486
 */
export function getXTCCityMarketCapacity(params: any) {
  return post(`/youth/map/combatMap/city/getSalesCompletionRate`, params);
}

/**
 * 小天才-商圈入驻情况
 * https://yapi.lanhanba.com/project/349/interface/api/89909
 */
export function getXTCSystemLabel(params: any) {
  return post(`/youth/map/combatMap/getSystemLabelCount`, params);
}

/**
 * 小天才-工作进展-一代完成情况
 * https://yapi.lanhanba.com/project/349/interface/api/90784
 */
export function getXTCCitySales(params: any) {
  return post(`/youth/map/combatMap/getBranchCompanySalesList`, params);
}

/**
 * 小天才-工作进展-获取城市工作进度统计
 * https://yapi.lanhanba.com/project/349/interface/api/90802
 */
export function getXTCStatisticByCity(params: any) {
  return post(`/youth/map/combatMap/workProgress/statisticByCity`, params, {
    needCancel: false
  });
}

/**
 * 小天才-工作进展-获取商圈工作进度统计
 * https://yapi.lanhanba.com/project/349/interface/api/90811
 */
export function getXTCStatisticByModelCapacity(params: any) {
  return post(`/youth/map/combatMap/workProgress/statisticByModelCapacity`, params, {
    needCancel: false
  });
}

/**
 * 小天才-工作进展-获取Mall工作进度统计
 * https://yapi.lanhanba.com/project/546/interface/api/90100
 */
export function getXTCStatisticByMall(params: any) {
  return post(`/youth/map/combatMap/workProgress/statisticByMall`, params, {
    needCancel: false
  });
}

/**
 * 废弃：小天才-全国视角-工作进展-获取Mall工作进度统计
 * https://yapi.lanhanba.com/project/532/interface/api/90352
 */
export function getXTCByGroupByLeveMall(params: any) {
  return post(`/youth/map/combatMap/getMallDataGroupByLevel`, params);
}

/**
 * 小天才-工作进展-获取售点工作进度统计
 * https://yapi.lanhanba.com/project/546/interface/api/90109
 */
export function getXTCStatisticByShop(params: any) {
  return post(`/youth/map/combatMap/workProgress/statisticByShop`, params, {
    needCancel: false
  });
}

/**
 * 小天才-品牌开店列表
 * https://yapi.lanhanba.com/project/532/interface/api/90316
 */
export function getXTCQueryTendency(params: any) {
  return post(`/youth/map/combatMap/queryTendency`, params);
}

/**
 * 小天才-品牌开店趋势
 * https://yapi.lanhanba.com/project/546/interface/api/90325
 */
export function getXTCQueryMonthTendency(params: any) {
  return post(`/youth/map/combatMap/queryMonthTendency`, params);
}

/**
 * 小天才-分公司hover-城市
 * https://yapi.lanhanba.com/project/349/interface/api/90856
 */
export function getXTCCompanyHoverCity(params: any) {
  return post(`/youth/map/combatMap/branchCompany/hover/statisticByCity`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司hover-商圈
 * https://yapi.lanhanba.com/project/349/interface/api/90874
 */
export function getXTCCompanyHoverArea(params: any) {
  return post(`/youth/map/combatMap/branchCompany/hover/statisticByModelCapacity`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司hover-Mall
 * https://yapi.lanhanba.com/project/349/interface/api/90892
 */
export function getXTCCompanyHoverMall(params: any) {
  return post(`/youth/map/combatMap/branchCompany/hover/statisticByModelCluster`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司hover-售点
 * https://yapi.lanhanba.com/project/349/interface/api/90910
 */
export function getXTCCompanyHoverSales(params: any) {
  return post(`/youth/map/combatMap/branchCompany/hover/statisticByShop`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司基本信息
 * https://yapi.lanhanba.com/project/349/interface/api/90946
 */
export function getXTCCompanyInfo(params: any) {
  return post(`/youth/map/combatMap/branchCompany/baseInfo`, params);
}

/**
 * 小天才-分公司-管辖的城市的基本信息
 * https://yapi.lanhanba.com/project/349/interface/api/91477
 */
export function getXTCCityInfo(params: any) {
  return post(`/youth/map/combatMap/city/baseInfo`, params);
}

/**
 * 小天才-省代视角-工作进展-获取城市工作进度统计
 * https://yapi.lanhanba.com/project/349/interface/api/90955
 */
export function getXTCCompanyStatisticByCity(params: any) {
  return post(`/youth/map/combatMap/branchCompany/workProgress/statisticByCity`, params, {
    needCancel: false
  });
}

/**
 * 小天才-省代视角-工作进展-获取商圈工作进度统计
 * https://yapi.lanhanba.com/project/349/interface/api/90964
 */
export function getXTCCompanyByModelCapacity(params: any) {
  return post(`/youth/map/combatMap/branchCompany/workProgress/statisticByModelCapacity`, params, {
    needCancel: false
  });
}


/**
 * 小天才-省代视角-工作进展-获取Mall工作进度统计
 * https://yapi.lanhanba.com/project/349/interface/api/90973
 */
export function getXTCCompanyLeveMall(params: any) {
  return post(`/youth/map/combatMap/branchCompany/workProgress/statisticByModelCluster`, params, {
    needCancel: false
  });
}

/**
 * 小天才-省代视角-工作进展-获取售点工作进度统计
 * https://yapi.lanhanba.com/project/349/interface/api/90982
 */
export function getXTCCompanyByShop(params: any) {
  return post(`/youth/map/combatMap/branchCompany/workProgress/statisticByShop`, params, {
    needCancel: false
  });
}

/**
 * 小天才-城市hover-行政区
 * https://yapi.lanhanba.com/project/349/interface/api/90865
 */
export function getXTCCityHoverDistrict(params: any) {
  return post(`/youth/map/combatMap/city/hover/statisticByDistrict`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司hover-商圈
 * https://yapi.lanhanba.com/project/349/interface/api/90883
 */
export function getXTCCityHoverArea(params: any) {
  return post(`/youth/map/combatMap/city/hover/statisticByModelCapacity`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司hover-Mall
 * https://yapi.lanhanba.com/project/349/interface/api/90901
 */
export function getXTCCityHoverMall(params: any) {
  return post(`/youth/map/combatMap/city/hover/statisticByModelCluster`, params, {
    needCancel: false
  });
}

/**
 * 小天才-分公司hover-售点
 * https://yapi.lanhanba.com/project/349/interface/api/90919
 */
export function getXTCCityHoverSales(params: any) {
  return post(`/youth/map/combatMap/city/hover/statisticByShop`, params, {
    needCancel: false
  });
}

/**
 * 小天才分公司管辖城市-地图hover展示的销售趋势
 * https://yapi.lanhanba.com/project/349/interface/api/90937
 */
export function getXTCCitySalesTrend(params: any) {
  return post(`/youth/map/combatMap/city/hover/salesTrend`, params);
}


/**
 * 小天才-分公司视角-一代销量目标（信息窗模块）
 * https://yapi.lanhanba.com/project/349/interface/api/97684
 */
export function getXTCCityBranchCompanySalesTarget(params: any) {
  return post(`/youth/map/combatMap/branchCompany/salesTarget`, params);
}

/**
 * 小天才-城市视角-城市销量目标
 * https://yapi.lanhanba.com/project/349/interface/api/91504
 */
export function getXTCCitySalesTarget(params: any) {
  return post(`/youth/map/combatMap/city/salesTarget`, params);
}

/**
 * 小天才-城市视角-活跃用户热力
 * https://yapi.lanhanba.com/project/349/interface/api/91909
 */
export function getXTCCityActiveHeatMap(params: any) {
  return post(`/modelCluster/hotMap/active`, params);
}
